import React from 'react';
import CommitteeSection from '../components/committee/CommitteeSection';
import useCsvMembers from '../hooks/useCsvMembers';
import './CommitteePages.css';


const InternationalECRCommitteePage = () => {
  const members = useCsvMembers('/data/international_ecr_committee.csv');
  return (
    <CommitteeSection heading="International ECR Committee" members={members} />
  );
};

export default InternationalECRCommitteePage;
